<template>
  <div>
    <channel-detail-field>
      <div slot="label">Agent Name:</div>
      <div slot="value">{{ channel.rbm.agent_name }}</div>
    </channel-detail-field>

    <channel-detail-field class="mt-3">
      <div slot="label">Agent State:

      </div>
      <div slot="value">
        {{channel.rbm.agent_state | rbmAgentState}}&nbsp;
        <span id="agent_state_info" v-b-popover:uri_info.html.hover.right="statePopoverText">
          <icon name="info-circle" class="btn-icon"></icon>
        </span>
      </div>
    </channel-detail-field>

    <channel-detail-field class="mt-3"
                   v-if="channel.rbm.region">
      <div slot="label">Region:</div>
      <div slot="value">{{ channel.rbm.region | rbmRegion }}</div>
    </channel-detail-field>

    <div v-if="!editMode">
      <button-agent-state class="mt-3"
                          :agent-state="channel.rbm.agent_state"
                          :channel="channel"
                          :modal-id-create-agent="modalIdCreateAgent"
      ></button-agent-state>
    </div>

    <modal-register-rbm-agent
      :modalId="modalIdCreateAgent"
      :channelId="channel.id"></modal-register-rbm-agent>

  </div>
</template>

<script>
  import ChannelDetailField from '@/components/administration/common/Field'
  import 'vue-awesome/icons/info-circle'
  import ModalRegisterRbmAgent from './components/ModalRegisterRbmAgent'
  import ButtonAgentState from './components/ButtonAgentState'
  import enums from '@/common/enums'

  const states = enums.platforms.rbm.agentStates

  const statePopoverTexts = {
    [states.new]: 'The Agent is not registered with RBM yet. You can only send messages in Test Mode.',
    [states.createRequested]: 'Request for registration with RBM is being processed.',
    [states.created]: 'The Agent is registered with RBM. Messages can be sent to Tester phone numbers when the channel is in Production mode.',
    [states.launchRequested]: 'Request for launch RBM Agent is being processed.',
    [states.launched]: 'The Agent is fully production-ready.'
  }

  const stateHintNew = `This channel is not registered with RBM yet. Please use <b>Register Agent</b> button below to submit registration request.
    <br/>
    Switch the channel to <b>Test</b> mode if you want to try <a href="https://docs.amio.io/docs/rbm-getting-started-send-message" target="_blank">Send Message API</a> before registering.`
  const stateHintCreated = `The Agent can only send messages to Tester phone numbers.
    To add a Tester phone number, please contact us at <a href="mailto:support@amio.io.">support@amio.io</a>.
    <br/>
    <b>Launching</b> the Agent will enable sending messages to all phone numbers.
  `
  const stateHintLaunchInProgress = `We have received your request to <b>launch this agent</b>. We will reach out to you soon with more details.`

  export default {
    components: {
      ButtonAgentState,
      ChannelDetailField,
      ModalRegisterRbmAgent
    },

    props: {
      editMode: {
        type: Boolean,
        required: true
      }
    },

    store: {
      channel: 'administration.channelDetail.channel',
      organization: '_common.organization'
    },

    watch: {
      channel() {
        this.updateChannelAlert()
      }
    },

    data() {
      return {
        statePopoverTexts,
        stateHintNew,
        stateHintCreated,
        stateHintLaunchInProgress,
        modalIdCreateAgent: 'modal-create-agent'
      }
    },

    methods: {
      updateChannelAlert() {
        const agentStates = this.$enums.platforms.rbm.agentStates
        const alertEvent = this.$enums.alerts.events.channelInfo
        const alertType = this.$enums.alerts.types.primary

        switch (this.channel.rbm.agent_state) {
          case agentStates.new:
            this.$emit(alertEvent, true, alertType, this.stateHintNew)
            return
          case agentStates.created:
            this.$emit(alertEvent, true, alertType, this.stateHintCreated)
            return
          case agentStates.launchRequested:
            this.$emit(alertEvent, true, alertType, this.stateHintLaunchInProgress)
            return
          default:
            this.$emit(alertEvent, false)
        }
      }
    },
    computed: {
      statePopoverText() {
        return this.statePopoverTexts[this.channel.rbm.agent_state] || ''
      }
    },

    mounted() {
      this.updateChannelAlert()

      const updateModePopupEvent = this.$enums.alerts.events.updateModeView
      const docLink = 'https://docs.amio.io/v1.0/reference#rbm-messages-text'
      this.$emit(updateModePopupEvent, docLink)
    }
  }
</script>
